import { BaseController } from './common/base/controller';

export default class AppController extends BaseController {
  constructor(controllerService, $cookies) {
    'ngInject';
    super({ controllerService, $cookies });
  }

  $onInit() {
    const { authService } = this;

    // Assign
    this.isAuthenticated = authService.isAuthenticated();

    // Store language options in controller service
    this.controllerService.languageOptions = this.languageOptions;

    // Load and activate feature flagged snippets
    this.controllerService.featureFlagService.activateSnippets();

    // Redirect to initial url after login
    if (this.isAuthenticated) {
      this.redirectAfterLogin();
    }
  }

  redirectAfterLogin() {
    const initialUrl = this.$cookies.get('initialUrl');
    if (initialUrl) {
      this.$cookies.remove('initialUrl');
      return this.$location.url(initialUrl);
    }
  }

  logout() {
    const { authService, $state } = this;

    authService.logout();

    // Reload states after authentication change
    return $state.go('home', {}, { reload: true });
  }
}
